const fileReducer = (state = null, action) => {
    switch(action.type){

        case 'setFile':
            if (!state || !state.currentFile){
                return {
                    ...state, currentFile:action.payload, prevFile:action.payload
                }
            }else{
                return {
                    ...state, prevFile:state.currentFile, currentFile:action.payload
                }
            }
            
        default:
            return state
    }
}

export default fileReducer